exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-56[data-v-08f49bd7]{height:56px!important}.v-app-bar[data-v-08f49bd7]{background-color:#2c3e50!important}#user_name_title[data-v-08f49bd7]{font-size:.95rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-08f49bd7","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AppBar.vue
// module id = 847
// module chunks = 0